<td>{{ audit.createdAt | date: 'M/d/yyyy h:mm a' }}</td>
<td>
  <div>Added Provider Office Association</div>
  @if (!loadingProviderOffice) {
    <div>
      @if (displayNpi) {
        <span>
          NPI: {{ providerOffice.provider.npi }}
          <app-copy-to-clipboard [text]="providerOffice.provider.npi" />
          @if (providerOffice.provider.npi) {
            <a target="_blank" href="/capture-admin/providers/{{ providerOffice.provider.npi }}">
              <fa-icon [icon]="['fas', 'external-link-alt']" size="sm" />
            </a>
          }
        </span>
      }
      @if (displayFax) {
        <span>
          Fax: <app-office-fax [office]="providerOffice.office" [allowLinkToOffice]="false" />
        </span>
      }
    </div>
  } @else {
    <mat-spinner class="mt-2" [diameter]="30" />
  }
</td>
<td>
  <div class="overflow-auto" style="max-height: 600px;" [innerHTML]="newValueHtml"></div>
</td>
<td>--</td>
<td>{{ audit.user?.email | blankValueDash }}</td>
